import React, { useEffect, useState } from "react";
import {
  Button,
  Box,
  styled,
  Typography,
  Grid,
  AccordionDetails as AccDet,
  Accordion as Acc,
  AccordionSummary as AccSum,
  Alert as AlertMUI,
  IconButton,
  Checkbox,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { es } from "date-fns/locale";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { ExpandMore } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Icon } from "@iconify/react";
import * as XLSX from "xlsx/xlsx.js";
import VisibilityIcon from "@mui/icons-material/VisibilityOutlined";

import { useScrollToTop } from "../../hooks/useScrollToTop";
import { Divider } from "../../components/Divider";
import { TypoTooltip } from "../../components/TypoTooltip";
import { CustomInputField, CustomModalDialog } from "../../components";
import {
  resetPdf,
  addListDocsStackMassive,
  UploadMetadataBatchFile,
  GetQuestionTypes,
  getFileCustomInfoMasive,
  GetContentTemplate,
  GetTemplatesActive,
  GetCategoriesTemplate,
} from "../../store/actions";
import { MassiveService } from "../../services/MassiveService";
import { FileFlowService } from "../../services/FileFlowService";
import iconDocument from "../../assets/icons/Documento.png";
import { Alert } from "../../components/Alert";
import { Loader } from "../../components/Loader";
import { DocumentButton } from "./DocumentButton";
import { UploadGenericControl } from "../../components/UploadGenericControl";
import iconExel from "../../assets/icons/IconTemplateDownload.png";
import { GenericTable } from "../../components/GenericTable";
import VisorPDF from "../../components/Viewer/VisorPDF";
import { b64toUrl } from "../../utils";
import BackdropComponent from "../../components/BackDrop";
import { ToastNotification } from "../../components/toastNotification";
import { WhiteTooltip } from "../../components/WhiteTooltip";

const ButtonCustom = styled(Button)(({ theme }) => ({
  marginRight: 5,
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", // Customize the shadow values as needed
  "&:hover": {
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Shadow on hover
  },
  color: "#424242",
  fontWeight: 500,
}));

const DocButtonLoaded = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  borderBottom: "1px solid #CCCCCC",
  borderRadius: 0,
  padding: "6px 8px",
  width: "100%",
}));

const RootStyle = styled(Box)(({ theme }) => ({
  margin: "0 auto",
  width: "100%",
  maxWidth: "95%",
  transition: "height 500ms ease",
}));

const Accordion = styled(Acc)(({ theme }) => ({
  "&.MuiAccordion-root": {
    boxShadow: "none !important",
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled(AccSum)(({ theme }) => ({
  borderBottom: "1px solid red",
  borderBottomColor: theme.palette.secondary.main40,
  padding: 0,
  "& .MuiAccordionSummary-content": {
    margin: 0,
  },
}));
const AccordionDetails = styled(AccDet)(({ theme }) => ({
  padding: 20,
}));

export const CaptureFileMassiveTab = (props) => {
  const { control, register, watch, setValue } = useForm({ mode: "onBlur" });

  const folioIdSolicitud = sessionStorage.getItem("FileId");
  const [file, setfile] = useState(null);
  const [fileBase64, setfileBase64] = useState(null);
  const [docSelectorStage, setdocSelectorStage] = useState("init");
  const [confirmFile, setconfirmFile] = useState(false);
  const [openaccordion, setopenaccordion] = useState(true);
  const [templateUploadOption, setTemplateUploadOption] = useState(null);

  const [nameDocumentCurrent, setNameDocumentCurrent] = useState("");
  const [metaDataDocumentCurrent, setMetaDataDocumentCurrent] = useState(null);
  const [actionCurrent, setActionCurrent] = useState("");
  const rdTypeChange = watch("rdTypeChange");

  const dispatch = useDispatch();
  const newFileState = useSelector((state) => state.NewFile);
  const listDocStackMassiveDataState = useSelector(
    (state) => state.ListDocStackMassiveData
  );

  useScrollToTop();

  useEffect(() => {
    if (fileBase64 === null) {
      changeFile();
    }
  }, [fileBase64]);

  useEffect(() => {
    dispatch(
      getFileCustomInfoMasive({
        Body: {
          FileId: folioIdSolicitud,
        },
      })
    );
    setValue("rdTypeChange", "Carga de documento"); //"Plantilla")//"Carga de documento")
  }, []);

  useEffect(() => {
    if (newFileState.document?.file) {
      const file = newFileState.document.file;
      setfile(file);
    }
  }, [newFileState]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      listDocStackMassiveDataState.ListDocStack !== undefined &&
      listDocStackMassiveDataState.ListDocStack !== null &&
      (actionCurrent === "add" || actionCurrent === "next")
    ) {
      if (actionCurrent === "add") {
        handleAddAnotherDocument();
      } else if (actionCurrent === "next") {
        handleSetupParticipants();
      }
      setActionCurrent("");
    }
  }, [listDocStackMassiveDataState]);

  useEffect(() => {
    console.log("rdTypeChange: ", rdTypeChange);
    if (rdTypeChange == "Plantilla") {
      setdocSelectorStage("SelectTemplates");
    } else {
      setdocSelectorStage("init");
    }
  }, [rdTypeChange]);

  const changeFile = () => {
    dispatch(resetPdf());
    setfile(null);
    setfileBase64(null);
    setconfirmFile(false);
  };

  let onSubmitUploadDocumentMetadata = async (data, action) => {
    try {
      // console.log("onSubmitUploadDocumentMetadata: ", data, action);
      setActionCurrent(action);
      // console.log("metaDataDocumentCurrent: ", metaDataDocumentCurrent)
      var dateCurrentExp =
        data.validityDefaultDocument !== undefined &&
        data.validityDefaultDocument !== null
          ? new Date(data.validityDefaultDocument)
          : null;
      let request = {
        BatchUploadDocument_Id: metaDataDocumentCurrent.BatchUploadDocument_Id,
        Public: false,
        Check: data.rdTypeProcessDocs === "docProcesoRevision" ? true : false,
        Sign: data.sign,
        OnlyView: data.rdTypeProcessDocs === "docComplementario" ? true : false,
        SameValidityFile: true,
        Validity:
          data.validityDocument !== undefined && data.validityDocument !== null
            ? data.validityDocument
            : dateCurrentExp !== undefined && dateCurrentExp !== null
            ? dateCurrentExp
            : null,
        UploadMetadata: true,
        Questions: null,
      };
      console.log("request++++Carga documental++++: ", request);
      const massiveService = MassiveService.getInstance();
      const response = await massiveService.UploadTemplateMetaData(request);
      console.log("response++++++++: ", response);

      const requestAddListDocsMassive = {
        FileId: folioIdSolicitud,
        DocumentConfiguration: {
          ...request,
          ...metaDataDocumentCurrent,
        },
        DocResponseId: response.Body.Response.BatchUploadDocument_Id,
        documentProps: {
          DocResponseId: response.Body.Response.BatchUploadDocument_Id,
          DocumentName: metaDataDocumentCurrent.FileName,
        },
        Type: metaDataDocumentCurrent.TypeDocumentoProcess,
      };
      dispatch(addListDocsStackMassive(requestAddListDocsMassive));
    } catch (error) {
      ToastNotification({
        icon: "error",
        text: "Ha ocurrido un error." + error,
      });
      console.log(error);
    }
  };

  const handleAddAnotherDocument = () => {
    setdocSelectorStage("init");
    setopenaccordion(true);
    changeFile();
  };

  const agregarStageParticipante = async () => {
    const fileFlowService = FileFlowService.getInstance();
    await fileFlowService.registerStatusStage({
      File_id: folioIdSolicitud,
      Status: "Configuración de participantes",
      Result: null,
    });
  };

  const handleSetupParticipants = async () => {
    var listDocsMailmerge = listDocStackMassiveDataState.ListDocStack.filter(
      (item) => item.Type === "DOCX con campos" || item.Type === "PDF editable"
    );
    if (listDocsMailmerge?.length > 0) {
      setdocSelectorStage("changeTemplate");
    } else {
      agregarStageParticipante();
      const someProcess = listDocStackMassiveDataState.ListDocStack.filter(
        (doc) =>
          doc.Sign ||
          doc.Check ||
          doc.DocumentConfiguration.Sign ||
          doc.DocumentConfiguration.Check
      );

      if (docSelectorStage === "init") {
        if (someProcess.length > 0) {
          dispatch(
            getFileCustomInfoMasive({
              Body: {
                FileId: folioIdSolicitud,
              },
            })
          );
          props.handleNextStep();
        } else if (someProcess.length === 0) {
          dispatch(
            getFileCustomInfoMasive({
              Body: {
                FileId: folioIdSolicitud,
              },
            })
          );
          props.handleSetStep(3);
        }
      }
      if (docSelectorStage === "information") {
        if (someProcess.length > 0) {
          props.handleNextStep();
        }
      }
    }
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={es}
      dateFormats={{ dayOfMonth: "dd", month: "MM", year: "yyyy" }}
    >
      <RootStyle>
        <Accordion
          disableGutters
          defaultExpanded
          expanded={file && confirmFile ? true : openaccordion}
          onChange={() => setopenaccordion(!openaccordion)}
        >
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography variant="titulo">
              {templateUploadOption == 1
                ? "Verificación de información"
                : templateUploadOption == 2
                ? "Solicitud de llenado de información"
                : file && confirmFile
                ? "Información del documento - " + nameDocumentCurrent
                : file && confirmFile
                ? "Documento - " + nameDocumentCurrent
                : "Prepare un documento para solicitar que sea revisado y/o firmado"}
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ paddingLeft: 0, paddingTop: 16 }}>
            {docSelectorStage === "init" && (
              <>
                <Typography variant="body1" sx={{ my: 2 }}>
                  Carga los documentos que formarán parte del expediente, estos
                  documentos podrán ser editables o solo de lectura.
                </Typography>

                <CustomInputField
                  register={register}
                  inputType="radio"
                  control={control}
                  name="rdTypeChange"
                  radioValues={[
                    {
                      value: "Carga de documento",
                      label: "Carga de documento",
                    },
                    {
                      value: "Plantilla",
                      label: "Plantilla",
                    },
                  ]}
                  validations={{ required: true }}
                  required={true}
                />
                {rdTypeChange === "" ? (
                  <AlertMUI
                    iconMapping={{
                      warning: (
                        <Icon
                          icon="mdi:information-variant-circle"
                          fontSize={30}
                          style={{ color: "#FBBF28" }}
                        />
                      ),
                    }}
                    severity="warning"
                    sx={{
                      backgroundColor: "secondary.warningAlert",
                      ".MuiAlert-icon": {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                  >
                    Puedes cargar plantillas las cuales deberán estar en formato
                    word y podrás configurar campos, para esto el campo deberá
                    estar precedido de un signo de #, sin espacios y caracteres
                    especiales. <br></br>
                    Ejemplo: #nombre#, #NOMBRE_APELLIDOS#, #nombre_apellidos#,
                    #nombreapellidos#, #NOMBRE#
                  </AlertMUI>
                ) : null}
                <Box sx={(theme) => ({ boxShadow: theme.shadows[9], mt: 2 })}>
                  {listDocStackMassiveDataState.ListDocStack.map((doc, i) => (
                    <DocumentButton
                      key={doc.DocResponseId}
                      doc={doc.documentProps}
                      listDocs={true}
                      IsMassive={true}
                    />
                  ))}
                  <DocumentButton
                    doc={{ Name: "Añadir documento" }}
                    onSelect={() => {
                      setdocSelectorStage("upload");
                    }}
                  />
                </Box>
              </>
            )}

            {docSelectorStage === "upload" && (
              <>
                <UploadFileComponent
                  onChange={(file, base64, extension, fileUrl, metaData) => {
                    setfile(file);
                    setfileBase64(base64);
                    if (file !== undefined && file !== null) {
                      setNameDocumentCurrent(file.name.split(".")[0]);
                    }
                    setMetaDataDocumentCurrent(metaData);
                  }}
                />
              </>
            )}

            {file && confirmFile && docSelectorStage === "information" && (
              <DetailedInformationUploadedFile
                metaDataDocument={metaDataDocumentCurrent}
                NameDocumentCurrent={nameDocumentCurrent}
                onClick={(data, action) => {
                  if (action === "add") {
                    setValue("rdTypeChange", "Carga de documento");
                  }
                  onSubmitUploadDocumentMetadata(data, action);
                }}
              />
            )}

            {docSelectorStage === "changeTemplate" && (
              <>
                {templateUploadOption == 1 ? (
                  <Typography variant="body1" sx={{ my: 2 }}>
                    Verifica que la información sea correcta, si existe algún
                    error deberás modificarlo y cargar nuevamente el archivo
                    presionando el botón <b>actualizar archivo</b>.
                  </Typography>
                ) : templateUploadOption == 2 ? (
                  <Typography variant="body1" sx={{ my: 2 }}>
                    Los siguientes campos serán solicitados a los firmantes para
                    su captura, la información capturada será insertada a las
                    plantillas.
                  </Typography>
                ) : (
                  <>
                    <Typography variant="body1" sx={{ my: 2 }}>
                      Si cuentas con la información complementaría, descarga el
                      formato de carga (Excel), agrega la información y al
                      finalizar, adjunta tu archivo en la plataforma.
                    </Typography>
                    <AlertMUI
                      iconMapping={{
                        warning: (
                          <Icon
                            icon="mdi:information-variant-circle"
                            fontSize={30}
                            style={{ color: "#FBBF28" }}
                          />
                        ),
                      }}
                      severity="warning"
                      sx={{
                        backgroundColor: "secondary.warningAlert",
                        ".MuiAlert-icon": {
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        },
                      }}
                    >
                      Descarga el formato de Excel, y agrega la información
                      complementaría.<br></br>
                      Si no cuentas con la información del usuario, podrás
                      ingresarla manualmente en la sección.
                    </AlertMUI>
                  </>
                )}
                <UploadFileTemplateComponent
                  setTemplateUploadOption={setTemplateUploadOption}
                  HandleNextStep={() => {
                    props.handleNextStep();
                  }}
                  FileId={folioIdSolicitud}
                />
              </>
            )}

            {docSelectorStage === "SelectTemplates" && (
              <>
                <Typography variant="body1" sx={{ my: 2 }}>
                  Para incorporar la plantilla, comience eligiendo la categoría
                  correspondiente. A continuación, realice una búsqueda de la
                  plantilla deseada dentro de esa categoría y, una vez ubicada,
                  simplemente haga clic en el cuadro para seleccionarla.
                </Typography>

                <DetailTemplatesUploaded
                  setdocSelectorStage={setdocSelectorStage}
                  setValue={setValue}
                  handleConfirm={(data, base64, metaData) => {
                    setfile({
                      name: data.FileName,
                    });
                    setfileBase64(base64);
                    setNameDocumentCurrent(
                      data.FileName.replace(
                        data.Extension.replace(/\s+/g, ""),
                        ""
                      )
                    );
                    setMetaDataDocumentCurrent(metaData);
                    setconfirmFile(true);
                    setopenaccordion(false);
                    setdocSelectorStage("information");
                  }}
                />
              </>
            )}
          </AccordionDetails>
        </Accordion>

        <Grid container spacing={2} justifyContent="center" sx={{ mt: 4 }}>
          {file && !confirmFile && (
            <Grid item xs={12} sm={4}>
              <Button
                fullWidth
                variant="contained"
                sx={{ height: 45, px: 10 }}
                onClick={() => {
                  setconfirmFile(true);
                  setopenaccordion(false);
                  setdocSelectorStage("information");
                }}
              >
                Siguiente
              </Button>
            </Grid>
          )}

          {docSelectorStage === "init" && (
            <Grid item xs={12} sm={4}>
              <Button
                fullWidth
                variant="contained"
                sx={{ height: 45, px: 10 }}
                onClick={handleSetupParticipants}
                disabled={!listDocStackMassiveDataState.ListDocStack.length > 0}
              >
                Siguiente
              </Button>
            </Grid>
          )}
        </Grid>
      </RootStyle>
    </LocalizationProvider>
  );
};

const UploadFileComponent = (props) => {
  const [isChangeFile, setIsChangeFile] = useState(null);
  return (
    <>
      {!isChangeFile ? (
        <Typography variant="body1" textAlign={"justify"} sx={{ mt: 2 }}>
          Carga los documentos que formarán parte de la solicitud, estos
          documentos podrán ser editables o de solo lectura. Prepara un
          documento a cargar del tipo pdf o docx.
        </Typography>
      ) : (
        <>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Asegúrate que el documento sea el correcto y presiona el botón
            siguiente.
          </Typography>
          <Typography
            variant="body2"
            sx={{ mt: 1, display: "flex", alignItems: "center" }}
          >
            Si el documento no es el correcto, presiona el botón de eliminar{" "}
            <Icon icon="ph:trash-light" fontSize={19} sx={{ ml: 3, mr: 3 }} /> y
            carga el archivo correcto.
          </Typography>
        </>
      )}
      <UploadGenericControl
        UploadTemplate={true}
        Accept=".docx,.pdf"
        onChange={(file, base64, extension, fileUrl, metaData) => {
          setIsChangeFile(base64);
          props.onChange(file, base64, extension, fileUrl, metaData);
        }}
      />
    </>
  );
};

const UploadFileTemplateComponent = (props) => {
  const { control, register, watch } = useForm({ mode: "onBlur" });

  const [base64File, setBase64File] = useState(null);
  const [loadFile, setLoadFile] = useState(false);
  const [loadActiveInformation, setLoadActiveInformation] = useState(false);

  const [columnsTable, setColumnsTable] = useState([]);
  const [rowsTable, setRowsTable] = useState([]);

  const watchRdTypeProcessDocs = watch("rdTypeProcessDocs");
  const uploadMetadataBatchFileDataState = useSelector(
    (state) => state.UploadMetadataBatchFileData
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      uploadMetadataBatchFileDataState.items !== undefined &&
      uploadMetadataBatchFileDataState.items !== null &&
      loadFile
    ) {
      setLoadFile(false);
      var respuestaValida =
        uploadMetadataBatchFileDataState.items?.Response?.Result.filter(
          (itemFilter) => itemFilter.State === false
        );
      console.log(
        "uploadMetadataBatchFileDataState: respuestaValida ",
        respuestaValida
      );
      if (respuestaValida?.length === 0) {
        props.HandleNextStep();
      } else {
        if (
          columnsTable?.filter((item) => item.accessor === "statusError")
            ?.length == 0
        ) {
          columnsTable.push({ Header: "", accessor: "statusError" });
        }
        if (
          rowsTable?.length > 0 &&
          rowsTable?.filter(
            (item) => item.status !== undefined && item.status !== null
          )?.length == 0
        ) {
          const newArray = rowsTable.map((item) => {
            var BuscarId = respuestaValida.find(
              (itemVal, index) =>
                parseInt(itemVal.ClaveSolicitud) ==
                parseInt(item.Clave_Solicitud_Consecutiva)
            )?.ErrorToolTip;
            console.log("Item validate BuscarId:  ", BuscarId);
            return {
              ...item,
              estatus: BuscarId === "" || BuscarId === undefined ? false : true,
              statusError:
                BuscarId === "" || BuscarId === undefined ? "" : BuscarId,
            };
          });
          setRowsTable(newArray);
        }
      }
    } else if (
      uploadMetadataBatchFileDataState.error !== undefined &&
      uploadMetadataBatchFileDataState.error !== null &&
      loadFile
    ) {
      setLoadFile(false);
      Alert({
        icon: "error",
        text: uploadMetadataBatchFileDataState.error,
        okbtntext: "Aceptar",
      });
    }
  }, [uploadMetadataBatchFileDataState]);

  useEffect(() => {
    console.log("columnsTable: ", columnsTable);
    if (
      columnsTable?.filter((item) => item.accessor === "estatus")?.length == 0
    ) {
      columnsTable.push({ Header: "Estatus", accessor: "estatus" });
    }
  }, [columnsTable]);

  useEffect(() => {
    if (
      rowsTable?.length > 0 &&
      rowsTable?.filter(
        (item) => item.estatus !== undefined && item.estatus !== null
      )?.length == 0
    ) {
      // Copia el arreglo original y agrega la nueva columna "precio"
      const newArray = rowsTable.map((item) => {
        return {
          ...item,
          estatus: Object.values(item).includes("") ? true : false,
        };
      });
      setRowsTable(newArray);
    }
  }, [rowsTable]);

  const handleDownloadTemplate = async () => {
    const massiveService = MassiveService.getInstance();
    const responseExcel = await massiveService.GetUploadMetadataTemplate(
      props.FileId
    );
    const url = window.URL.createObjectURL(new Blob([responseExcel.data.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "File_" + props.FileId + "_Template.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleFileChange = async (file) => {
    if (file === undefined || file === null) {
      return;
    }
    const reader = new FileReader();

    reader.onload = (event) => {
      const workbook = XLSX.read(event.target.result, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        blankrows: false,
        defval: "",
        cellDates: true,
        dateNF: "dd/mm/yyyy",
        raw: false,
      });

      var arregloFiltrado = jsonData?.slice(1)?.map((subarreglo) => {
        // Filtrar los elementos no vacíos en cada subarreglo
        return subarreglo.filter((item) => item !== "");
      });
      console.log("arregloFiltrado: ", arregloFiltrado);
      setColumnsTable(
        arregloFiltrado[0].map((column, index) => ({
          Header: column?.replace(/ /g, "_"),
          accessor: column?.replace(/ /g, "_"),
        }))
      );
      setRowsTable(
        arregloFiltrado.slice(1).map((r) =>
          r.reduce((acc, x, i, index) => {
            var formatFecha = x.includes("/") ? new Date(x) : null;
            // console.log("arregloFiltrado[0][i]: x ", x)
            acc[arregloFiltrado[0][i]?.replace(/ /g, "_")] =
              x.includes("/") && formatFecha !== null
                ? formatFecha.toLocaleDateString("es-ES")
                : x;
            return acc;
          }, {})
        )
      );
    };
    reader.readAsBinaryString(file);
  };

  return (
    <Box
      sx={{
        mt: 3,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        backgroundColor: "transparent",
      }}
    >
      {!loadActiveInformation &&
      watchRdTypeProcessDocs === "chkCargarInformacion" &&
      base64File === null ? (
        <Box
          sx={{
            position: "absolute",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            paddingRight: "1em",
            paddingTop: "0em",
          }}
        >
          <IconButton
            xs={{ width: 60 }}
            title="Descargar plantilla"
            color="secondary"
            onClick={() => handleDownloadTemplate()}
          >
            <img alt="ImagenDescarga" src={iconExel} style={{ width: 45 }} />
          </IconButton>
        </Box>
      ) : null}

      {!loadActiveInformation && base64File === null ? (
        <CustomInputField
          register={register}
          inputType="radio"
          control={control}
          name="rdTypeProcessDocs"
          radioValues={[
            {
              value: "chkCargarInformacion",
              label: "Cargar información",
            },
            {
              value: "chkSolicitarInformacion",
              label: "Solicitar información",
            },
          ]}
          validations={{ required: true }}
        />
      ) : null}

      {watchRdTypeProcessDocs === "chkCargarInformacion" &&
      base64File === null ? (
        <UploadGenericControl
          Accept=".xlsx"
          onChange={(file, base64, extension, fileUrl) => {
            setBase64File(base64);
            handleFileChange(file);
            if (base64 !== null) {
              props.setTemplateUploadOption(1);
            } else {
              props.setTemplateUploadOption(null);
            }
          }}
        />
      ) : null}
      {columnsTable?.length > 0 && rowsTable?.length > 0 && (
        <GenericTable
          Columns={columnsTable}
          Data={rowsTable}
          onClickRow={() => {}}
          TotalRows={rowsTable.length}
          TotalPages={1}
          PageCurrent={1}
          onClickChangePage={() => {}}
          ShowPagination={false}
        />
      )}

      {loadActiveInformation && (
        <InformationFillingRequestComponent
          onReturn={() => {
            setLoadActiveInformation(false);
          }}
          HandleNextStep={() => {
            props.HandleNextStep();
          }}
        />
      )}

      {!loadActiveInformation && (
        <Grid container spacing={2} justifyContent="center" sx={{ mt: 4 }}>
          <Divider />
          {/* {console.log("watchRdTypeProcessDocs: ", watchRdTypeProcessDocs)} */}
          {base64File && (
            <Grid item xs={12} sm={4}>
              <LoadingButton
                loading={loadFile}
                fullWidth
                variant="outlined"
                sx={{ height: 45, px: 10 }}
                disabled={
                  (watchRdTypeProcessDocs === "chkCargarInformacion" &&
                    loadFile) ||
                  !watchRdTypeProcessDocs == "chkSolicitarInformacion" ||
                  loadFile
                }
                onClick={() => {
                  setBase64File(null);
                  setColumnsTable(null);
                  setRowsTable(null);
                }}
              >
                Actualizar archivo
              </LoadingButton>
            </Grid>
          )}
          {rowsTable?.filter((item) => item.estatus === true)?.length >
          0 ? null : (
            <Grid item xs={12} sm={4}>
              <Button
                fullWidth
                variant="contained"
                sx={{ height: 45, px: 10 }}
                onClick={() => {
                  if (watchRdTypeProcessDocs === "chkSolicitarInformacion") {
                    setLoadActiveInformation(true);
                    props.setTemplateUploadOption(2);
                  } else {
                    let request = {
                      File_Id: props.FileId,
                      FileContentB64: base64File,
                    };
                    console.log(
                      ".:UploadFileTemplateComponent:. event: ",
                      request
                    );
                    dispatch(UploadMetadataBatchFile(request));
                    setLoadFile(true);
                  }
                }}
                disabled={
                  watchRdTypeProcessDocs === null ||
                  (watchRdTypeProcessDocs === "chkCargarInformacion" &&
                    base64File === null) ||
                  !watchRdTypeProcessDocs == "chkSolicitarInformacion" ||
                  loadFile
                }
              >
                Siguiente
              </Button>
            </Grid>
          )}
        </Grid>
      )}
    </Box>
  );
};

const DetailedInformationUploadedFile = (props) => {
  const folioIdSolicitud = sessionStorage.getItem("FileId");
  const [isEditable, setIsEditable] = useState(null);

  const {
    control,
    handleSubmit,
    register,
    watch,
    setValue,
    formState,
    resetField,
  } = useForm({ mode: "onBlur" });

  const [savingDocument, setsavingDocument] = useState(false);
  const watchValidity = watch("validity");

  const dispatch = useDispatch();
  const newFileState = useSelector((state) => state.NewFile);
  const fileState = useSelector((state) => state.File);

  const handleValidateDateMax = () => {
    const ValidityDate = newFileState.editStack
      ? fileState.item?.Validity
      : newFileState.file?.fileForm?.FileConfiguration?.Validity;
    if (ValidityDate?.length > 0) {
      const limDate = new Date(ValidityDate);
      return limDate.setDate(limDate.getDate());
    } else {
      return new Date();
    }
  };

  useEffect(() => {
    dispatch(
      getFileCustomInfoMasive({
        Body: {
          FileId: folioIdSolicitud,
        },
      })
    );
  }, []);

  useEffect(() => {
    setValue("sign", true);
  }, []);

  useEffect(() => {
    if (
      props.NameDocumentCurrent !== undefined &&
      props.NameDocumentCurrent != null
    ) {
      setValue("docName", props.NameDocumentCurrent);
    }
  }, [props.NameDocumentCurrent]);

  useEffect(() => {
    if (isEditable) {
      setValue("chkRequiereCapturaInfo", true);
    }
  }, [isEditable]);

  useEffect(() => {
    if (
      props.metaDataDocument !== undefined &&
      props.metaDataDocument != null
    ) {
      var activeEditable =
        props.metaDataDocument?.TypeDocumentoProcess === "PDF editable"
          ? true
          : props.metaDataDocument?.TypeDocumentoProcess === "DOCX con campos"
          ? true
          : false;
      setIsEditable(activeEditable);
      if (activeEditable) {
        setValue("chkRequiereCapturaInfo", activeEditable);
      }
    }
  }, [props.metaDataDocument]);

  useEffect(() => {
    if (watchValidity === "noassign") {
      resetField("validityDefaultDocument");
      resetField("validityDocument");
    } else if (watchValidity === "assign") {
      resetField("validityDefaultDocument");
    } else if (watchValidity === "assignExpDefault") {
      resetField("validityDocument");
      const ValidityDate =
        newFileState.editStack === true
          ? fileState.item?.Validity
          : newFileState.file?.fileForm?.FileConfiguration?.Validity
          ? newFileState.file?.fileForm?.FileConfiguration?.Validity?.toString()
          : "";
      if (ValidityDate?.length > 0) {
        const limDate = new Date(ValidityDate);
        setValue("validityDefaultDocument", limDate);
      }
    }
  }, [watchValidity, resetField]);

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="body1">
        Captura la información relacionada con el documento.
      </Typography>
      <CustomInputField
        register={register}
        label="Nombre del documento"
        control={control}
        name="docName"
        validations={{ required: true }}
        error={!!formState.errors["docName"]}
        helperText={formState.errors["docName"]?.message}
        required={true}
      />
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mt: 1 }}>
        Vigencia documental <spam style={{ color: "#C20E30" }}>*</spam>
      </Typography>
      <Box>
        <CustomInputField
          inputType="radio"
          control={control}
          name="validity"
          radioValues={[
            { value: "assign", label: "Asignar una fecha" },
            {
              value: "assignExpDefault",
              label: "Misma vigencia documental",
            },
            {
              value: "noassign",
              label: "Sin vigencia",
            },
          ]}
          validations={{ required: true }}
          error={!!formState.errors["validity"]}
          helperText={formState.errors["validity"]?.message}
          required={true}
        />
      </Box>
      {watchValidity === "assign" && (
        <CustomInputField
          register={register}
          inputType="date"
          control={control}
          name="validityDocument"
          validations={{ required: true }}
          error={!!formState.errors[`validityDocument`]}
          helperText={formState.errors[`validityDocument`]?.message}
          sxInput={{ maxWidth: 500 }}
          required={true}
          minDate={Date.now()}
          defaultValue={""}
        />
      )}
      {watchValidity === "assignExpDefault" && (
        <CustomInputField
          register={register}
          inputType="date"
          control={control}
          name="validityDefaultDocument"
          validations={{ required: true }}
          error={!!formState.errors[`validityDefaultDocument`]}
          helperText={formState.errors[`validityDefaultDocument`]?.message}
          minDate={Date.now()}
          maxDate={handleValidateDateMax()}
          sxInput={{ maxWidth: 500 }}
          disabled={true}
          defaultValue={""}
        />
      )}
      <TypoTooltip sxTypo={{ mt: 2 }} text="" />
      {isEditable ? (
        <>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mt: 3 }}>
            Selecciona el tipo de operación que se realizará en el documento
          </Typography>
          <CustomInputField
            inputType="check"
            control={control}
            name="chkRequiereCapturaInfo"
            label="Se requiere captura de información"
            tooltipText=""
            defaultValue={true}
            disabled={true}
            error={!!formState.errors["chkRequiereCapturaInfo"]}
            helperText={formState.errors["chkRequiereCapturaInfo"]?.message}
          />
        </>
      ) : (
        <>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, mt: 2, mb: 0.8 }}
          >
            Selecciona el tipo de operación que se realizará sobre el documento{" "}
            <spam style={{ color: "#C20E30" }}>*</spam>
          </Typography>
          <CustomInputField
            register={register}
            inputType="radio"
            control={control}
            name="rdTypeProcessDocs"
            radioValues={[
              {
                value: "docProcesoRevision",
                label: "El documento tendrá un proceso de revisión",
              },
              {
                value: "docComplementario",
                label:
                  "Documento complementario (solo lectura) o directo a firma",
              },
            ]}
            validations={{ required: true }}
            error={!!formState.errors["rdTypeProcessDocs"]}
            helperText={formState.errors["rdTypeProcessDocs"]?.message}
            required={true}
          />
        </>
      )}
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mt: 3 }}>
        Firma de documento
      </Typography>
      <CustomInputField
        inputType="check"
        control={control}
        name="sign"
        label="El documento tendrá un proceso de firmado electrónico"
        tooltipText="Proceso donde una persona acepta y da por válido el
                  contenido del documento para confirmar su integridad,
                  empleando datos legítimos de firma electrónica."
        defaultValue={true}
        disabled={true}
        error={!!formState.errors["sign"]}
        helperText={formState.errors["sign"]?.message}
      />

      <Grid container spacing={2} justifyContent="center" sx={{ mt: 4 }}>
        <Divider />
        <Grid item xs={12} sm={4}>
          <LoadingButton
            fullWidth
            variant="outlined"
            sx={{ height: 45, px: 10 }}
            onClick={handleSubmit((data) => {
              props.onClick(data, "add");
            })}
          >
            Añadir otro documento
          </LoadingButton>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Button
            fullWidth
            variant="contained"
            sx={{ height: 45, px: 10 }}
            onClick={handleSubmit((data) => {
              setsavingDocument(true);
              props.onClick(data, "next");
            })}
            disabled={savingDocument}
          >
            {console.log(
              "DOCUMENTO valid",
              !formState.isValid,
              formState.isValid,
              savingDocument
            )}
            Siguiente
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

const InformationFillingRequestComponent = (props) => {
  const [templateMetadataList, setTemplateMetadataList] = useState([]);
  const [sendDataActive, setSendDataActive] = useState(false);
  const [listOptionsTypes, setListOptionsTypes] = useState([]);

  const listDocStackMassiveDataState = useSelector(
    (state) => state.ListDocStackMassiveData
  );

  const dispatch = useDispatch();
  const QuestionsTypesState = useSelector((state) => state.QuestionsTypesData);

  useEffect(() => {
    dispatch(GetQuestionTypes(""));
  }, []);

  useEffect(() => {
    var listFilterDocs = listDocStackMassiveDataState?.ListDocStack?.filter(
      (item) => item.Type === "DOCX con campos" || item.Type === "PDF editable"
    );
    if (listFilterDocs?.length > 0) {
      var listAddFields = [];

      listFilterDocs.forEach((itemDoc, index) => {
        itemDoc.DocumentConfiguration.FieldsFound?.forEach((itemFields) => {
          console.log("itemFields: ", itemFields);

          var newObject = {
            Id: index + 1,
            NombreCampo: itemFields,
            NombreEtiqueta:
              itemFields.split("#")?.length > 1
                ? itemFields.split("#")[1]?.replace(/_|#|-|@|<>|^[H]/g, " ")
                : itemFields.replace(/_|#|-|@|<>|^[H]/g, " "),
            TipoDato: "Text", /// Indica el tipo de dato default que quiere mosttarse en el control a pintar.
            Required: true,
          };
          var objectExists = listAddFields.some(
            (item) => item.NombreCampo === newObject.NombreCampo
          );
          if (!objectExists) {
            // Agregar el objeto al arreglo solo si no existe
            listAddFields.push(newObject);
          }
        });
      });
      setTemplateMetadataList(listAddFields);
    }
  }, [listDocStackMassiveDataState?.ListDocStack]);

  useEffect(() => {
    if (
      QuestionsTypesState.items?.Response?.QuestionTypes !== undefined &&
      QuestionsTypesState.items?.Response?.QuestionTypes?.length > 0
    ) {
      var listUpdate = QuestionsTypesState.items?.Response?.QuestionTypes?.map(
        (item) =>
          item.Value === undefined ? { ...item, Value: item.Code } : item
      );
      setListOptionsTypes(listUpdate);
      console.log("listUpdate----------------------: ", listUpdate);
    }
  }, [QuestionsTypesState]);

  const columnsTable = [
    {
      Header: "Nombre de campo",
      accessor: "NombreCampo",
      Toltip: "Identificador que aparece en tu documento como metadato.",
    },
    {
      Header: "Etiqueta captura",
      accessor: "NombreEtiqueta",
      type: "Editable",
      Toltip: "Nombre que le aparecerá al usuario en su formulario.",
    },
    {
      Header: "Tipo de dato",
      accessor: "TipoDato",
      type: "Option",
      listOption: listOptionsTypes,
      Toltip: "Dato que deseas que sea solicitado al firmante.",
    },
    { Header: "Obligatorio", accessor: "select", type: "check" },
  ];

  const handleSendData = async (data) => {
    const DataFormat = templateMetadataList?.map((item) => {
      return {
        Code: item.NombreCampo,
        Name: data[`EtiquetaCaptura_${item.NombreEtiqueta}`],
        DataType: data[`TipoDato_${item.NombreEtiqueta}`],
        Required: data[`CheckCaptura_${item.NombreEtiqueta}`],
      };
    });

    var listDocsMailmerge = listDocStackMassiveDataState.ListDocStack.filter(
      (item) => item.Type === "DOCX con campos" || item.Type === "PDF editable"
    );

    if (listDocsMailmerge?.length > 0) {
      var error = 0;

      await listDocsMailmerge.forEach(async (itemDoc, index) => {
        // console.log("Items Docs request: ", itemDoc)
        if (
          itemDoc.DocumentConfiguration === undefined ||
          itemDoc.DocumentConfiguration === null
        ) {
          return;
        }

        const DataFormatForDocument = DataFormat.filter((itemFormat) =>
          itemDoc.DocumentConfiguration.FieldsFound.some(
            (itemField) => itemField === itemFormat.Code
          )
        );
        // console.log("DataFormatForDocument2: ", DataFormatForDocument)

        let request = {
          BatchUploadDocument_Id:
            itemDoc.DocumentConfiguration.BatchUploadDocument_Id,
          Public: itemDoc.DocumentConfiguration.Public,
          Check: itemDoc.DocumentConfiguration.Check,
          Sign: itemDoc.DocumentConfiguration.Sign,
          OnlyView: itemDoc.DocumentConfiguration.OnlyView,
          SameValidityFile: itemDoc.DocumentConfiguration.SameValidityFile,
          Validity: itemDoc.DocumentConfiguration.Validity,
          UploadMetadata: false,
          Questions: DataFormatForDocument,
        };

        console.log("Evento de carga masiva request: ", request);
        const massiveService = MassiveService.getInstance();
        const responseUMD = await massiveService.UploadTemplateMetaData(
          request
        );
        console.log("response++++++++: ", responseUMD);
        if (responseUMD?.Body?.Response?.BatchUploadDocument_Id != 0) {
          error++;
        }
      });

      if (error > 0) {
        Alert({
          icon: "error",
          text: "Ocurrio un error al intentar registrar los metadatos, intente nuevamente",
          okbtntext: "Aceptar",
        });
      } else {
        props.HandleNextStep();
      }
    }
  };

  return (
    <Box
      sx={{
        mt: 3,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        backgroundColor: "transparent",
      }}
    >
      {QuestionsTypesState.loading ? (
        <Loader>Cargando datos...</Loader>
      ) : columnsTable?.length > 0 &&
        templateMetadataList?.length > 0 &&
        listOptionsTypes?.length > 0 &&
        (!sendDataActive || sendDataActive) ? (
        <GenericTable
          Columns={columnsTable}
          Data={templateMetadataList}
          onClickRow={() => {}}
          ShowPagination={false}
          sendDataActive={sendDataActive}
          HandleSendData={handleSendData}
          setSendDataActive={setSendDataActive}
        />
      ) : null}

      <Grid container spacing={2} justifyContent="center" sx={{ mt: 4 }}>
        <Divider />
        <Grid item xs={12} sm={4}>
          <LoadingButton
            fullWidth
            variant="outlined"
            sx={{ height: 45, px: 10 }}
            onClick={() => {
              props.onReturn();
            }}
          >
            Atras
          </LoadingButton>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Button
            fullWidth
            variant="contained"
            sx={{ height: 45, px: 10 }}
            onClick={() => {
              setSendDataActive(true);
            }}
          >
            Siguiente
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

const DetailTemplatesUploaded = (props) => {
  const { control, handleSubmit, register, formState } = useForm({
    mode: "onBlur",
  });

  const [resultCategories, setResultCategories] = useState([]);
  const [resultTemplates, setResultTemplates] = useState([]);
  const [viewTemplate, setViewTemplate] = useState(false);
  const [dataFile, setDataFile] = useState(null);
  const [sendDataFile, setSendDataFile] = useState(false);
  const [documentMetaDataCurrent, setDocumentMetaDataCurrent] = useState(false);
  const [loading, setLoading] = useState(false);

  const GetContentTemplateState = useSelector(
    (state) => state.GetContentTemplateData
  );
  const GetTemplatesActiveState = useSelector(
    (state) => state.GetTemplatesActiveData
  );
  const GetCategoriesTemplateState = useSelector(
    (state) => state.GetCategoriesTemplateData
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GetCategoriesTemplate("aa"));
  }, []);

  useEffect(() => {
    if (GetCategoriesTemplateState?.items) {
      const filesTable = GetCategoriesTemplateState?.items?.map((itemData) => {
        return {
          Value: itemData.Id,
          Name: itemData.Name,
        };
      });
      setResultCategories(filesTable);
    }
  }, [GetCategoriesTemplateState]);

  useEffect(() => {
    if (GetTemplatesActiveState?.items) {
      const filesTable = GetTemplatesActiveState?.items?.map((itemData) => {
        return {
          ...itemData,
          Checked: null,
        };
      });
      setResultTemplates(filesTable);
      dispatch(GetTemplatesActive(null, true));
    }
  }, [GetTemplatesActiveState]);

  useEffect(async () => {
    if (GetContentTemplateState?.items) {
      let nameFile = GetContentTemplateState?.items?.m_Item2;
      let base64 = GetContentTemplateState?.items?.m_Item3
        ? `data:application/pdf;base64,${GetContentTemplateState?.items?.m_Item3}`
        : `data:application/pdf;base64,${GetContentTemplateState?.items?.m_Item1}`;
      let blobUrl = await b64toUrl(base64);
      setDataFile({
        URL: blobUrl,
        Base64: base64,
        Name: GetContentTemplateState?.items?.m_Item2,
      });

      if (sendDataFile) {
        setUploadTemplate(
          GetContentTemplateState?.items?.m_Item1,
          GetContentTemplateState?.items?.m_Item2
        );
      } else {
        setLoading(false);
      }
      dispatch(GetContentTemplate(null, true));
    } else if (GetContentTemplateState?.error) {
      setLoading(false);
      Alert({
        icon: "error",
        text: GetContentTemplateState?.error,
        okbtntext: "Aceptar",
      });
    }
  }, [GetContentTemplateState]);

  useEffect(async () => {
    if (
      documentMetaDataCurrent !== undefined &&
      documentMetaDataCurrent !== null &&
      sendDataFile
    ) {
      setSendDataFile(false);
      props.handleConfirm(
        resultTemplates?.find((item) => item.Checked == true),
        dataFile.Base64.replace("data:application/pdf;base64,", ""),
        documentMetaDataCurrent
      );
    }
  }, [documentMetaDataCurrent]);

  const GetContentData = (props) => {
    setLoading(true);
    dispatch(
      GetContentTemplate({
        template_Id: props.Template_Id,
        extension: props.Extension.replace(/\s+/g, ""),
      })
    );
  };

  const GetMetadataUploadTemplate = async (
    File_Id,
    base64,
    extension,
    fileName
  ) => {
    const request = {
      File_Id: File_Id,
      B64Content: base64,
      Extension: extension,
      FileName: fileName,
      ConvertDocumentToImage: true,
    };
    const massiveService = MassiveService.getInstance();
    const response = await massiveService.UploadTemplate(request);
    return response.Body;
  };

  const UploadTemplateFileToB64 = async (
    base64result,
    File_Id,
    extension,
    fileName
  ) => {
    try {
      var UrlResult = null;
      var MetaData = await GetMetadataUploadTemplate(
        File_Id,
        base64result,
        extension,
        fileName
      )
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.log(".:GetMetadataUploadTemplate:. error: ", error);
          return error;
        });
      if (
        MetaData.message !== undefined &&
        MetaData.message !== null &&
        MetaData.message !== ""
      ) {
        Alert({
          icon: "error",
          text: MetaData.message,
          okbtntext: "Aceptar",
        });
        return { base64result: null, UrlResult: null, MetaData: null };
      }

      if (extension === "docx") {
        const wordPdfB64 = `data:application/pdf;base64,${MetaData.Response.PdfB64ContentConvert}`;
        UrlResult = await b64toUrl(wordPdfB64);
      } else {
        const PdfB64 = `data:application/pdf;base64,${base64result}`;
        UrlResult = await b64toUrl(PdfB64);
      }
      return { base64result, UrlResult, MetaData };
    } catch (e) {
      return { base64result: null, UrlResult: null, MetaData: null };
    }
  };

  const setUploadTemplate = async (Base64Current, NameFile) => {
    try {
      const folioIdSolicitud = sessionStorage.getItem("FileId");
      let selectDocument = resultTemplates?.find(
        (item) => item.Checked == true
      );
      let base64 = Base64Current;
      let fileName = NameFile;

      const { base64result, UrlResult, MetaData } =
        await UploadTemplateFileToB64(
          base64,
          folioIdSolicitud,
          selectDocument.Extension.replace(/\s+/g, ""),
          fileName
        );
      if (base64result === null) {
        setDocumentMetaDataCurrent(null);
      } else {
        let response = {
          FileName: fileName,
          Extension: selectDocument.Extension.replace(/\s+/g, ""),
          ...MetaData.Response,
        };
        setDataFile({
          URL: UrlResult,
          Base64: base64result.replace("data:application/pdf;base64,", ""),
          Name: selectDocument.FileName,
        });
        setDocumentMetaDataCurrent(response);
      }
      setLoading(false);
      return true;
    } catch (error) {
      setLoading(false);
      console.log(error);
      Alert({
        icon: "error",
        text: error,
        okbtntext: "Aceptar",
      });
      return false;
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <BackdropComponent loading={loading} />
      <CustomInputField
        inputType="select"
        control={control}
        register={register}
        name="cmbCategory"
        label="Categoría"
        validations={{ required: true }}
        defaultValue=""
        optionsList={resultCategories}
        error={!!formState.errors["cmbCategory"]}
        helperText={formState.errors["cmbCategory"]?.message}
        required={true}
        onSelect={(data) => {
          const { value } = data.target;
          dispatch(GetTemplatesActive(value));
        }}
      />
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mt: 1 }}>
        Documentos
      </Typography>
      <Box>
        {resultTemplates.map((item, index) => (
          <DocumentListButton
            Id={`id_${index}`}
            TemplateId={item.Template_Id}
            Name={item.FileName}
            Checked={item.Checked}
            handleView={(data) => {
              GetContentData(item);
              setViewTemplate(true);
            }}
            handleSelect={(checked, TemplateId) => {
              const updatedItems = resultTemplates.map((item) =>
                item.Template_Id === TemplateId
                  ? { ...item, Checked: checked }
                  : { ...item, Checked: null }
              );
              setResultTemplates(updatedItems);
            }}
          />
        ))}
      </Box>
      <Grid container spacing={2} justifyContent="center" sx={{ mt: 4 }}>
        <Divider />
        <Grid item xs={12} sm={4}>
          <LoadingButton
            fullWidth
            variant="outlined"
            sx={{ height: 45, px: 10 }}
            onClick={(data) => {
              props.setdocSelectorStage("init");
              props.setValue("rdTypeChange", "Carga de documento");
            }}
          >
            Cancelar
          </LoadingButton>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Button
            fullWidth
            variant="contained"
            sx={{ height: 45, px: 10 }}
            onClick={handleSubmit((data) => {
              setSendDataFile(true);
              GetContentData(
                resultTemplates?.find((item) => item.Checked == true)
              );
            })}
            disabled={
              resultTemplates?.filter((item) => item.Checked == true)?.length ==
              0
            }
          >
            Aceptar
          </Button>
        </Grid>
      </Grid>

      <CustomModalDialog
        Open={viewTemplate}
        Title={`Plantilla - ${dataFile?.Name}`}
        OnClose={() => {
          setViewTemplate(false);
        }}
        Body={
          <VisorPDF
            parsingDoc={false}
            pdfUrl={dataFile?.URL}
            pdfName={dataFile?.Name}
            changeFile={() => {}}
          />
        }
      />
    </Box>
  );
};

const DocumentListButton = (props) => {
  return (
    <Box sx={{ mt: 2.5, width: "100%" }}>
      <DocButtonLoaded
        style={props.style}
        fullWidth
        sx={{ color: "#000" }}
        component={Box}
        id={props.Id}
      >
        <Box sx={{ width: "100%", display: "flex", alignItems: "center" }}>
          <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
            <Checkbox
              edge="start"
              checked={props.Checked}
              tabIndex={-1}
              disableRipple
              onChange={(event) => {
                const { checked } = event.target;
                let ValueChecked = checked ? true : null;
                props.handleSelect(ValueChecked, props.TemplateId);
              }}
            />

            <img
              style={{ width: 13, marginRight: 5 }}
              alt="imagenLogo"
              src={iconDocument}
            />
            <Typography
              variant="body2"
              component="span"
              sx={{
                fontSize: "14px !important",
              }}
            >
              {props.Name}
            </Typography>
          </Box>
          <Box sx={{ display: "flex" }}>
            <WhiteTooltip title="Ver plantilla">
              <IconButton
                onClick={() => {
                  props.handleView(props.TemplateId);
                }}
              >
                <VisibilityIcon sx={{ color: "black", fontSize: 26 }} />
              </IconButton>
            </WhiteTooltip>
          </Box>
        </Box>
      </DocButtonLoaded>
    </Box>
  );
};
